import React, { useEffect, useState } from "react";

const RencontresList = ({ discCode }) => {
  const [rencontres, setRencontres] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🎨 Couleurs vives
  const colors = [
    "#42a5f5", // bleu vif
    "#f06292", // rose vif
    "#66bb6a", // vert vif
    "#ff9800", // orange vif
    "#8e24aa", // violet vif
  ];

  useEffect(() => {
    const fetchRencontres = async () => {
      try {
        const response = await fetch(
          `http://localhost:8000/api/nb_rencontres/${discCode}/`
        );
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        setRencontres(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchRencontres();
  }, [discCode]);

  if (loading) return <p style={{ textAlign: "center" }}>Chargement...</p>;
  if (error)
    return (
      <p style={{ textAlign: "center", color: "red" }}>Erreur : {error}</p>
    );

  return (
    <div
      style={{
        padding: "30px", //  plus d’espace autour
        fontFamily: "Arial, sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "30px",
          color: "#031f05ff",
          fontSize: "38px", //  encore plus grand
          fontWeight: "bold",
        }}
      >
        Rencontres de : {rencontres[0]?.discipline || discCode}
      </h2>

      {rencontres.map((r, idx) => (
        <div
          key={r.idrencontre}
          style={{
            backgroundColor: colors[idx % colors.length],
            borderRadius: "20px",
            padding: "40px", //  cadre étiré
            marginBottom: "30px",
            boxShadow: "0 10px 20px rgba(0,0,0,0.3)",
            width: "95%", //  carte plus large
            maxWidth: "1000px", //  limite élargie
            textAlign: "center",
            color: "white",
            transition: "transform 0.25s ease, box-shadow 0.25s ease",
            fontSize: "22px", //  texte plus gros par défaut
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.05)";
            e.currentTarget.style.boxShadow = "0 14px 28px rgba(0,0,0,0.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.3)";
          }}
        >
          <p style={{ margin: "1px 0", lineHeight: "1", fontSize: "24px" }}>
            <strong>{r.stade}</strong> <br />
            <span style={{ fontWeight: "bold", fontSize: "18px" }}>
              {r.institution1}
            </span>{" "}
            <span
              style={{
                fontSize: "40px",
                fontWeight: "bold",
                color: "#ffeb3b",
              }}
            >
              {r.score1}
            </span>
            <span
              style={{
                fontSize: "40px",
                fontWeight: "bold",
                color: "#e3eeefff",
              }}
            >
              {" "}
              vs{" "}
            </span>
            <span
              style={{
                fontSize: "40px",
                fontWeight: "bold",
                color: "#ffeb3b",
              }}
            >
              {r.score2}{" "}
            </span>
            <span style={{ fontWeight: "bold", fontSize: "18px" }}>
              {r.institution2}
            </span>{" "}
          </p>

          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
              textAlign: "center",
              fontSize: "22px",
            }}
          >
            {r.athletes.map((a) => (
              <li
                key={a.athlete}
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr auto 1fr",
                  alignItems: "center",
                  fontWeight: "bold",
                  fontSize: "24px",
                  marginBottom: "15px",
                  color: "#1d1a04ff",
                }}
              >
                <p style={{ fontSize: "10px" }}>
                  {a.athlete}: {a.total_valsuivi}
                </p>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default RencontresList;
